
const Approach = () => {
  const steps = [
    {
      number: '01',
      title: 'Discovery & Assessment',
      description: 'We begin by understanding your current financial situation, goals, and concerns through comprehensive consultation.',
      icon: 'ri-search-line'
    },
    {
      number: '02',
      title: 'Strategy Development',
      description: 'Our experts create a personalised financial plan tailored to your unique needs and long-term objectives.',
      icon: 'ri-lightbulb-line'
    },
    {
      number: '03',
      title: 'Implementation',
      description: 'We put your plan into action with careful execution and coordination of all financial strategies.',
      icon: 'ri-rocket-line'
    },
    {
      number: '04',
      title: 'Ongoing Review',
      description: 'Regular monitoring and adjustments ensure your plan stays aligned with your evolving goals and market conditions.',
      icon: 'ri-refresh-line'
    }
  ];

  return (
    <section id="approach" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1B3A5F] mb-4">
            Our <span className="text-[#F5A623]">Approach</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            A proven methodology designed to deliver exceptional results and lasting financial success
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 h-full group hover:-translate-y-1">
                <div className="text-[#F5A623]/20 text-6xl font-bold mb-4">{step.number}</div>
                <div className="w-12 h-12 bg-gradient-to-br from-[#F5A623] to-[#E09612] rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${step.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#1B3A5F] mb-3">{step.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-2xl text-[#F5A623]"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#1B3A5F] to-[#2A4A6F] rounded-2xl p-12 text-center shadow-xl">
          <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">
            Why Choose Us?
          </h3>
          <p className="text-white/90 text-base mb-8 max-w-3xl mx-auto leading-relaxed">
            Our client-centric methodology ensures that every decision is made with your best interests in mind. We combine industry expertise with personalised service to deliver results that matter.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <i className="ri-user-heart-line text-4xl text-[#F5A623] mb-3"></i>
              <h4 className="text-white font-semibold mb-2">Personalised</h4>
              <p className="text-white/80 text-sm">Tailored to your needs</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <i className="ri-shield-check-line text-4xl text-[#F5A623] mb-3"></i>
              <h4 className="text-white font-semibold mb-2">Comprehensive</h4>
              <p className="text-white/80 text-sm">All aspects covered</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <i className="ri-line-chart-line text-4xl text-[#F5A623] mb-3"></i>
              <h4 className="text-white font-semibold mb-2">Results-Driven</h4>
              <p className="text-white/80 text-sm">Focused on outcomes</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <i className="ri-time-line text-4xl text-[#F5A623] mb-3"></i>
              <h4 className="text-white font-semibold mb-2">Long-Term</h4>
              <p className="text-white/80 text-sm">Sustainable strategies</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Approach;
